module.exports = __webpack_public_path__ + "img/chevron.dcf6d5e8.svg";